const conversationRoutes = [
  {
    path: '/profile/messages/messageList',
    name: 'Conversation',
    component: () => import('@/views/conversation/views/messageList/index.vue'),
  },
  {
    path: '/profile/messages/chat',
    name: 'Chat',
    component: () => import('@/views/conversation/views/chat/index.vue'),
  },
  {
    path: '/profile/messages/groupChat/:announcementId',
    name: 'GroupChat',
    component: () => import('@/views/conversation/views/groupChat/index.vue'),
  },
];

export default conversationRoutes;
